import { createContext } from 'react'

export type Theme = 'light' | 'dark'

export interface ThemeContextType {
  theme: Theme
  toggleTheme: () => void
  setTheme: (theme: Theme) => void
  resetToSystemTheme: () => void
  isSystemTheme: boolean
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)
